import axios from '@/utils/ajax/index'; // 倒入 api
// import fileExport from '@/utils/fileExport/index'; // 导出文件 api

// 待收费列表
export const pendingOrder = (params) => {
  return axios({
    url: '/order/pending',
    method: 'get',
    params,
  });
};

// 待收费详情
export const pendingOrderDetail = (data) => {
  return axios({
    url: `/order/pending/${data.id}`,
    method: 'get',
    data,
  });
};

// 通过批次号修改药品
export const modifyDrug = (params) => {
  return axios({
    url: '/order/drugs',
    method: 'get',
    params,
  });
};


// 已收费列表
export const completed = (params) => {
  return axios({
    url: '/order/completed',
    method: 'get',
    params,
  });
};

// 已收费详情
export const completedDetail = (params) => {
  return axios({
    url: `/order/completed/${params.id}`,
    method: 'get',
  });
};

// 新建已退费
export const refund = (data) => {
  return axios({
    url: '/order/refund',
    method: 'POST',
    data,
  });
};

// 已退费列表
export const getRefund = (params) => {
  return axios({
    url: '/order/refund',
    method: 'GET',
    params,
  });
};

// 已退费列表-详情
export const getReundDetail = (params) => {
  return axios({
    url: `/order/refund/${params.id}`,
    method: 'GET',
    params,
  });
};

// 修改支付方式
export const changePayWay = (data) => {
  return axios({
    url: `/order/pending/${data.id}/balance`,
    method: 'put',
    data,
  });
};


// 非在线支付的回调接口
export const offlinePayCall = (data) => {
  return axios({
    url: '/order/pay/callback',
    method: 'post',
    data,
  });
};

// 修改待收费详情
export const editPending = (data) => {
  return axios({
    url: `/order/pending/${data.id}`,
    method: 'put',
    data,
  });
};

// 已欠费列表
export const getDebt = (params) => {
  return axios({
    url: '/order/debt',
    method: 'GET',
    params,
  });
};

// 已欠费列表
export const getDebtDetail = (params) => {
  return axios({
    url: `/order/debt/${params.id}`,
    method: 'GET',
    params,
  });
};

// 直接售药获取药品

export const sellDrugDetail = (params) => {
  return axios({
    url: '/order/sellDrug/drugs',
    method: 'GET',
    params,
  });
};

// 直接售药
export const sellDrug = (data) => {
  return axios({
    url: '/order/sellDrug',
    method: 'post',
    data,
  });
};

// 修改欠费支付结算方式
export const changeBalancePayWay = (data) => {
  return axios({
    url: '/order/debt/balance',
    method: 'put',
    data,
  });
};

// 发起在线支付
export const orderPay = (data) => {
  return axios({
    url: '/order/pay/pay',
    method: 'post',
    data,
  });
};

// 扫码支付
export const scanPay = (params) => {
  return axios({
    url: '/order/pay/scanPay',
    method: 'get',
    params,
  });
};

export const smallTicketPrint = (data) => {
  return axios({
    url: `/order/getOrderPrintInformation/${data.orderId}`,
    method: 'post',
    data,
  });
};


export default {
  pendingOrder,
  pendingOrderDetail,
  modifyDrug,
  completed,
  completedDetail,
  refund,
  changePayWay,
  offlinePayCall,
  editPending,
  getRefund,
  getReundDetail,
  getDebt,
  getDebtDetail,
  sellDrugDetail,
  sellDrug,
  changeBalancePayWay,
  orderPay,
  scanPay,
  smallTicketPrint,
  // flowExport,
};
